module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg5.fde25944.png";